(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tax-status-class', {
            parent: 'entity',
            url: '/tax-status-class?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.taxStatusClass.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tax-status-class/tax-status-classes.html',
                    controller: 'TaxStatusClassController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taxStatusClass');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tax-status-class-detail', {
            parent: 'entity',
            url: '/tax-status-class/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.taxStatusClass.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tax-status-class/tax-status-class-detail.html',
                    controller: 'TaxStatusClassDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taxStatusClass');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TaxStatusClass', function($stateParams, TaxStatusClass) {
                    return TaxStatusClass.get({id : $stateParams.id});
                }]
            }
        })
        .state('tax-status-class.new', {
            parent: 'tax-status-class',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-status-class/tax-status-class-dialog.html',
                    controller: 'TaxStatusClassDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                value: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tax-status-class', null, { reload: true });
                }, function() {
                    $state.go('tax-status-class');
                });
            }]
        })
        .state('tax-status-class.edit', {
            parent: 'tax-status-class',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-status-class/tax-status-class-dialog.html',
                    controller: 'TaxStatusClassDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TaxStatusClass', function(TaxStatusClass) {
                            return TaxStatusClass.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tax-status-class', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tax-status-class.delete', {
            parent: 'tax-status-class',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-status-class/tax-status-class-delete-dialog.html',
                    controller: 'TaxStatusClassDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TaxStatusClass', function(TaxStatusClass) {
                            return TaxStatusClass.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tax-status-class', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
